module.exports = __webpack_public_path__ + "img/1_001.66913290.jpg";